
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import CustomAnimation from '../animation/customAnimation';
import jQuery from "jquery";

const customAnmation = new CustomAnimation();

class Contact {
  init() {
    this.initPage();
    this.initParallax();
  }

  initPage = () => {

    // background
    jQuery('.header_background').css("background-image", "url("+ jQuery('.header_background').data('bg-image') +")");
    jQuery('.contact_background').css("background-image", "url("+ jQuery('.contact_background').data('bg-image') +")");

  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateHeaderImage('.header_background');

    customAnmation.animateBgImage('.contact_background', '.contact');
    customAnmation.animateScaleDown('.contact_form');
    customAnmation.animateText('.contact_text');
  }
}

export default Contact;
